module.exports = __webpack_public_path__ + "static/img/da1.b0834ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/da1.png
// module id = 1hB+
// module chunks = 1